import { Switch, Route, useLocation } from "react-router-dom";
import { TransitionGroup, CSSTransition } from "react-transition-group";

import Home from "../views/home/home";
import Favorites from "../views/favorites/favorites";
import Stories from "../views/stories/stories";
import About from "../views/about/about";
import Collections from "../views/collections/collections";
import ThingList from "../views/thingList/thingList";
import Artists from "../views/artists/artists";
import PhotosGallery from "../views/photosgallery/photosgallery";
import Arpage from "../views/arpage/arpage";

const MainRoute = () => {
  let location = useLocation();

  return (
    <TransitionGroup
      style={{
        flex: 1,
        flexDirection: "column",
        display: "flex",
        justifyContent: "space-between",
      }}
    >
      <CSSTransition
        // key={location.key}
        classNames="fade"
        timeout={300}
      >
        <Switch location={location}>
          {/* homepage */}
          <Route path="/" exact component={Home} />
          <Route path="/reset-password/:resetId" exact component={Home} />
          <Route path="/favorites" exact component={Favorites} />
          <Route path="/stories" exact component={Stories} />
          <Route path="/about" exact component={About} />
          <Route path="/collections" exact component={Collections} />
          <Route path="/artist-list" exact component={Artists} />
          <Route path="/photosgallery" exact component={PhotosGallery} />
          <Route path="/arpage" exact component={Arpage} />
          <Route path="/artists/:artistId" component={ThingList} />
          <Route
            path="/:thingName(amps|photos|posters|tshirts|instruments|liveaid)"
            exact
            component={ThingList}
          />
          <Route path="/:projectId([0-9]{7})" exact component={Home} />
        </Switch>
      </CSSTransition>
    </TransitionGroup>
  );
};

export default MainRoute;
